import { useCallback, useEffect, useState } from "react";

export const DELETE_ARM_WINDOW_MS = 4_000;

type DeleteArmKey = string | number;

export function useDeleteArming<T extends DeleteArmKey>(windowMs = DELETE_ARM_WINDOW_MS) {
  const [armedKey, setArmedKey] = useState<T | null>(null);

  useEffect(() => {
    if (armedKey === null) return;
    const timer = window.setTimeout(() => setArmedKey(null), windowMs);
    return () => window.clearTimeout(timer);
  }, [armedKey, windowMs]);

  const requestDelete = useCallback((key: T): boolean => {
    if (armedKey === key) {
      setArmedKey(null);
      return true;
    }
    setArmedKey(key);
    return false;
  }, [armedKey]);

  const resetDeleteArm = useCallback(() => setArmedKey(null), []);
  const isDeleteArmed = useCallback((key: T) => armedKey === key, [armedKey]);

  return { armedKey, isDeleteArmed, requestDelete, resetDeleteArm };
}
